import React, { useState, useRef } from "react";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import { langIdSelector } from "store/selectors/app";
import { setLanguage, setTranslations } from "store/reducers/app";
import AppController from "controllers/app";
import ClickOutside from "components/common/clickOutside";
import FlagAM from "assets/images/FlagAM.png";
import FlagRU from "assets/images/FlagRU.png";
import FlagUK from "assets/images/FlagUK.png";
import OpenVector from "assets/images/OpenVector.png";
import CloseVector from "assets/images/CloseVector.png";

const LANGUAGES = [
  { id: "AM", name: "Հայ", flag: FlagAM },
  { id: "US", name: "Eng", flag: FlagUK },
  { id: "RU", name: "Рус", flag: FlagRU },
];

export default function TranslationDropdown() {
  const [modalOpened, setModalOpened] = useState(false);
  const buttonRef = useRef(null);
  const selectedLanguage = useSelector(langIdSelector);
  const dispatch = useDispatch();

  const handleToggleModal = (e) => {
    e.stopPropagation();
    setModalOpened((prev) => !prev);
  };

  const handleCloseModal = (e) => {
    if (e && buttonRef.current && buttonRef.current.contains(e.target)) {
      return;
    }
    setModalOpened(false);
  };

  const handleLanguageChange = (id) => async () => {
    dispatch(setLanguage(id));
    localStorage.setItem("langId", id);

    try {
      const fetchedTranslations = await AppController.getTranslations(id);
      localStorage.setItem(
        `translations_${id}`,
        JSON.stringify(fetchedTranslations)
      );
      dispatch(setTranslations(fetchedTranslations));
    } catch (error) {
      console.error("Error fetching translations:", error);
    }

    window.dispatchEvent(new Event("storage"));
    handleCloseModal();
  };

  const selectedLang =
    LANGUAGES.find((lang) => lang.id === selectedLanguage) || LANGUAGES[0];

  return (
    <div className="language-dropdown">
      <button
        ref={buttonRef}
        className="dropdown-toggle"
        onClick={handleToggleModal}
      >
        <img
          src={selectedLang.flag}
          alt="language"
          className="l-image-wrapper"
        />
        <span>{selectedLang.name}</span>
        <img
          src={modalOpened ? CloseVector : OpenVector}
          alt="toggle dropdown"
          className="dropdown-icon"
        />
      </button>

      {modalOpened && (
        <ClickOutside onClickOutside={handleCloseModal}>
          <div className="l-dropdown">
            {LANGUAGES.map((lang) => (
              <div
                key={lang.id}
                className={`dropdown-item ${
                  lang.id === selectedLanguage ? "selected" : ""
                }`}
                onClick={handleLanguageChange(lang.id)}
              >
                <img
                  src={lang.flag}
                  alt={lang.name}
                  className="l-image-wrapper"
                />
                <span>{lang.name}</span>
              </div>
            ))}
          </div>
        </ClickOutside>
      )}
    </div>
  );
}
